<template>
  <div v-show="isSuccess" class="list-block media-list scroll-container">
    <div class="paySuccess-pic">
      <img src="https://resource.rcclchina.com.cn/paySuccess/SC.png" />
    </div>
    <div class="paySuccess">
      <div class="paySuccess-main">
        <div class="paySuccess-text">
          <img
              src="https://resource.rcclchina.com.cn/mobileSearchPackage/06---u5b8cu6210@2x.png"
          />
          <div>
            <p class="paySuccess-title">支付成功！</p>
            <p class="paySuccess-title">美好旅程即将开启！</p>
          </div>
        </div>

        <!-- <div class="cruiseShare-cruiseInfo-QRCode f-dn">
                  <div id="qrcode" title="http://wechatapp.rcclchina.com.cn:8080/Rccl.Cruise/CruiseDetail?shipCode=SC&amp;sailDate=2021-05-26&amp;from=paysuccess"><canvas width="65" height="65" style="display: none;"></canvas><img src="data:image/png;base64,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" style="display: block;"></div>
                  <span>扫码分享行程</span>
              </div> -->
        <div class="paySuccess-linkBtn">
          <a href="/Rccl.UserCenter/OrderRecord/List" class="external"
          >订到超棒旅程，瞄一眼火热订单！</a
          >
        </div>
      </div>
      <template v-if="isRow == false">
        <div class="shorex">
        <div class="shorex-title"><span style="color: #006AB6">皇家</span>岸上观光</div>
        <div class="shorex-text">精品游行程享套餐优惠</div>
        <img class="shorex-img" src="https://resource.rcclchina.com.cn/wechatMiniProgram/shorex/select-shorex.png" alt=""/>
        </div>
        <div class="shorex-tab ShoreExcursions">
          <PaySuccessShoreExcursions
              :shoreData="pageData"
              :allShorexList="allShorexList"
              :payShorexOnlyStr="payShorexOnlyStr"
          ></PaySuccessShoreExcursions>
        </div>
      </template>
      <template v-if="false">
      <div class="hsbcBanner" v-if="hsbcBanners && hsbcBanners.length">
        <Swiper
            ref="bannerSwiper"
            :options="swiperOptions"
            class="swiper-container swiper-topics topics"
            @click-slide="onShowPopupsImg"
        >
          <SwiperSlide
              v-for="(item, i) in hsbcBanners"
              :key="i"
              class="swiper-slide promoBannerLink external"
          >
            <div>
              <img :src="item.image" alt=""/>
            </div>
          </SwiperSlide>
          <div
              ref="swiper-pagination"
              class="swiper-pagination"
              v-if="hsbcBanners.length > 1"
              slot="pagination"
          ></div>
        </Swiper>
      </div>
      </template>
      <div v-if="info" class="survey-question-main">
        <questionnaire :infoList="info"
                       :isShowTitleNumber="true"
                       :isTitleStyle="false"
                       :submitStyle="true"
                       :orderId="orderId"
        ></questionnaire>
      </div>
    </div>

    <div class="paySuccess-tips">
      <div class="line"></div>
      <div class="paySuccess-tips-title">请仔细阅读办理登船注意事项！</div>
      <div class="paySuccess-tips-content">
        <p>
          支付成功后，将需要3个工作日左右对您的订单进行确认及系统操作，订单确认后，请务必在开航7天之前办理在线值船，打印“登船证”并于登船当天携带。如遇紧急情况，请您拨打皇家客服专线：400-820-7293。
        </p>
      </div>
    </div>

    <div class="notice-wrap" v-if="false">
      <div class="notice js_shorex active">
        <div class="notice-line"></div>
        <div class="notice-txt">岸上观光服务</div>
      </div>
      <div class="shorex">
        <div class="notice-item">
          <div class="no-shorex" v-if="!hasShorexes">
            很抱歉，该航次岸上观光服务尚未开放选定，选定开放后，我们会在第一时间以短信的方式通知您，您也可以密切关注皇家加勒比官方网站。
          </div>
          <div class="selectShorex-css" v-else-if="!selectedFreeShorex">
            <p>您尚未预订任何岸上观光服务</p>{{selectedFreeShorex}}
            <span class="selectShorex_JS" @click="showShorexPopup()"
              >请选择</span
            >
          </div>
          <div v-else>
            <div class="notice-item-title">
              皇家常规游 (免费赠送)
              <span class="line"></span>
              <span class="up-shorex" @click="showShorexPopup()"
                >升级精品游</span
              >
            </div>
            <div
              class="notice-item-text shorex-item-text"
              v-for="(trip, i) in selectedFreeShorex.shorexTrips"
              :key="'freeShorexTrip_' + i"
            >
              <p style="color: black">
                {{ trip.tripName }} - {{ trip.tripTime }}
              </p>
              <div class="shorex-item-trip" v-html="trip.description"></div>
            </div>
            <div class="shorex-item-tips">
              注：<br />
              1)
              目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。<br />
              2)
              目的地产品及行程可能因相关政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。<br />
              3)
              皇家行前订目前只提供全程观光优惠套餐。您可于登船后购买单一港口观光产品。优惠套餐与单一港口观光产品均数量有限，先到先得。<br />
              4)
              如需取消已预订的精品游订单，请联系皇家行前订客服协助操作。
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom_img" @click="goToPcp" v-if="isRow == false">
      <img src="https://resource.rcclchina.com.cn/logo/pcp-mb-banner.jpg" />
    </div>

    <PaySuccessShorex
      :shorexes="payShorexes"
      :bookings="bookings"
      :isShow="isShowShorex"
      :bookingCruises="bookingCruises"
      :onGoBack="closeShorexPopup"
    />
    <popups-img v-show="isShowPopupsImg"
                :imgUrl="popupsImgUrl"
                @closePopups="onClosePopups">
    </popups-img>
  </div>
</template>

<script>
import api from "@/api";
import Questionnaire from "@/components/Questionnaire/Questionnaire.vue";
import PaySuccessShoreExcursions from "@/components/Booking/PaySuccessShoreExcursions.vue";
import PopupsImg from "@/components/Cruise/popupsImg.vue";
import { Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import "swiper/css/swiper.css";
const PaySuccessShorex = () => import("@/components/Booking/PaySuccessShorex");
export default {
  name: "PaySuccess",
  components: {
    PaySuccessShoreExcursions,
    Swiper,
    SwiperSlide,
    PopupsImg,
    Questionnaire,
    PaySuccessShorex,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      isSuccess: true,
      isShowShorex: false,
      pageData: {},
      info: null,
      orderId: '',
      hsbcBanners:null,
      popupsImgUrl:'',
      isShowPopupsImg:false,
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
        },
        loop: false,
        autoplay: {
          delay: 5000,
        },
      },
      allShorexList: [],
      payShorexOnlyStr: ""
    };
  },
  beforeMount() {
    this.$store.commit("SET_PAGE_TITLE", "支付成功");
    this.$store.dispatch("HIDE_HEADER_BAR", {
      isHideHeader: false,
      isHideFooter: true,
    });
    this.initPage();
    window.onpopstate = () => {
      if (this.isShowShorex) {
        this.closeShorexPopup();
      }
    };
    let query = this.$route.query;
    this.type = query.type || 'HOME';
    this.getQuestions();
    this.orderId = query.orderId || ''
  },
  beforeDestroy() {
    this.$store.dispatch("HIDE_HEADER_BAR", {
      isHideHeader: false,
      isHideFooter: false,
    });
  },
  methods: {
    async initPage() {
      const userToken = this.$store.state.user.userToken;
      await this.getCruiseBanner()
      if (!userToken || userToken == "") {
        this.$router.push({
          name: "Login",
          query: {
            returnUrl: location.href,
          },
        });
        return;
      }
      const query = this.$router.currentRoute.query;
      if (!query.payMentId || query.payMentId == "") {
        // return this.$router.push({
        //   name: "BookingList",
        // });
      }
      const { success, data, errMsg } = await api.booking.paySuccessV2({
        paymentId: query.payMentId,
        userName: userToken,
      });
      if (!success) {
        console.error(errMsg);
        // return this.$router.push({
        //   name: "BookingList",
        // });
      }
      this.pageData = this.initBookingData(data);
      this.allShorexList = this.pageData.shorexList
      this.isSuccess = true;
      if (data.payShorexOnly) {
        this.payShorexOnlyStr = "该航次岸上观光精品游行程（付费）尚未开放选订，";
      } else {
        this.payShorexOnlyStr = "该航次岸上观光服务尚未开放选订，";
      }
    },
    // 预处理接口返回数据，把bookingcruise放到booking里面
    initBookingData(data) {
      if (data.apiBookings && data.bookingCruises) {
        data.apiBookings.forEach((booking) => {
          const cruise = data.bookingCruises.find(
            (r) => r.cruiseId == booking.cruisePartRecord_Id
          );
          booking.cruise = cruise;
        });
      }
      // 将 encBookingId 添加到 shorexList 的 shorexOrderInfos 中
      if (data.shorexList && data.apiBookings) {
        data.shorexList.forEach((shorex) => {
          if (shorex.shorexOrderInfos) {
            shorex.shorexOrderInfos.forEach((orderInfo) => {
              const booking = data.apiBookings.find(
                (r) => r.bookingId === orderInfo.bookingId
              );
              if (booking) {
                orderInfo.encBookingId = booking.encBookingId;
              }
            });
          }
        });
      }
      return data;
    },
    showShorexPopup() {
      this.isShowShorex = true;
      this.showPopup();
    },
    closeShorexPopup() {
      this.isShowShorex = false;
    },
    showPopup() {
      history.pushState({ page: "paySuccess" }, null);
    },
    async goToPcp() {
      const { data } = await api.user.getPcpToken();
      let token = "";
      if (data && data.length > 0) {
        token = data;
      }
      let url = `${process.env.VUE_APP_PCP_URL}/Rccl.Pcp/Home/Index?token=${token}`;
      if (this.firstBooking) {
        url += `&sailDate=${this.firstBooking.sailDate}&shipCode=${this.firstBooking.shipCode}&encBookingId=${this.firstBooking.encBookingId}`;
      }
      location.href = url;
    },
    async getQuestions() {
      this.$loading.show()
      const {success, data} = await api.questionnaire.getCampaignQuestions({
        type: this.type
      })
      this.$loading.hide()
      if(success) {
        this.info = this.surveyFormat(data,null);
      }
    },
    // 数据处理
    surveyFormat(rows, type, defaultVal){
      let customTypeIcon = {
        "Booking": "flowPath.png",
        "ImportantInfo": "info.png",
        "CustomerService": "service.png"
      }
      rows.categoryQuestionItems && rows.categoryQuestionItems.forEach((row,idx)=> {
        if(rows.categoryQuestionItems[0].questionItems[0].customType === "Point") {
          row.show = idx === 0;
        } else {
          row.show = true;
        }
        row.questionItems && row.questionItems.forEach((qtItem)=> {
          qtItem.value = qtItem.type === 4 ? defaultVal : null;
          qtItem.isFocus = false;
          qtItem.icon = customTypeIcon[qtItem.customType]
          if(qtItem.type === 4) {
            let indexList = [];
            for (let i = 1; i <= 10; i++) {
              indexList.push({
                text: i,
                selectClass: ""
              })
            }
            qtItem.indexList = indexList;
          }
          qtItem.optionItems && qtItem.optionItems.forEach((option)=> {
            option.checked = false;
            option.otherVal = "";
            option.isOther = option.optionName === "其他" || option.optionName === "其它"
          })
        })
        row.NO = (idx+1) > 9 ? (idx+1) : `0${idx+1}`
      });
      console.log(rows)
      return rows;
    },
    async getCruiseBanner() {
      const requestData = {
        businessType:2
      }
      const {success, data, errMsg} = await api.cruise.getCruiseBannerApi(requestData);
      if (success) {
        this.hsbcBanners = data
        // console.log(this.hsbcBanners)
      } else {
        this.$alert.show(errMsg);
      }
    },
    onShowPopupsImg(idx){
      this.popupsImgUrl = ''
      this.popupsImgUrl = this.hsbcBanners[idx].popupImageUrl
      this.isShowPopupsImg = true
    },
    onClosePopups(){
      this.isShowPopupsImg = false
    }
  },
  computed: {
    isRow(){
      return this.bookings[0] && this.bookings[0].isRow
    },
    bookings() {
      console.log(this.pageData,'bookings')
      return this.pageData.apiBookings || [];
    },
		firstBooking() {
			return this.bookings.length > 0 ? this.bookings[0]: null
		},
    bookingCruises() {
      return this.pageData.bookingCruises || [];
    },
    freeShorexes() {
      return this.pageData.freeShorexList || [];
    },
    payShorexes() {
      return this.pageData.shorexList || [];
    },
    hasShorexes() {
      return this.freeShorexes.length > 0 || this.payShorexes.length > 0;
    },
    selectedFreeShorex() {
      const shorexIds = this.bookings
        .filter((r) => r.shorexPartRecord_Id && r.shorexPartRecord_Id > 0)
        .map((r) => r.shorexPartRecord_Id);
      if (shorexIds.length == 0) {
        return {};
      }
      const freeShorex = this.freeShorexes.find(
        (r) => shorexIds.indexOf(r.id) >= 0
      );
      return freeShorex;
    },
  },
};
</script>

<style>
.shorex-item-trip,
.shorex-item-trip p,
.shorex-item-trip span {
  font-size: 12px !important;
  margin: 0px;
}
</style>

<style lang="less" scoped>
p {
  margin: 0;
}
.list-block {
  margin-bottom: 0px;
  .paySuccess-pic {
    height: 258px;
    img {
      width: 375px;
      height: 100%;
    }
  }
  .paySuccess {
    padding: 40px 0px 18px 0px;
    .paySuccess-main{
      padding: 0 26px;
    }
    background-color: #fff;
    .paySuccess-text {
      display: inline-block;
      vertical-align: middle;
      img {
        width: 44px;
      }
      > div {
        display: inline-block;
        .paySuccess-title {
          color: #333333;
          font-size: 20px;
          font-weight: bold;
          text-align: left;
          margin: 0;
        }
      }
    }
    .paySuccess-linkBtn {
      width: 300px;
      height: 46px;
      line-height: 46px;
      margin-top: 18px;
      text-align: center;
      margin: 10px auto 0 auto;
      background-image: -webkit-gradient(
        linear,
        right top,
        left top,
        from(#fad961),
        to(#febc10)
      );
      background-image: -webkit-linear-gradient(
        right,
        #fad961 0%,
        #febc10 100%
      );
      background-image: -moz-linear-gradient(right, #fad961 0%, #febc10 100%);
      background-image: -o-linear-gradient(right, #fad961 0%, #febc10 100%);
      background-image: linear-gradient(270deg, #fad961 0%, #febc10 100%);
      box-shadow: 0 4px 8px 0 rgba(254, 188, 16, 0.5);
      -webkit-box-shadow: 0 4px 8px 0 rgba(254, 188, 16, 0.5);
      -moz-box-shadow: 0 4px 8px 0 rgba(254, 188, 16, 0.5);
      border-radius: 24px;
      -webkit-border-radius: 24px;
      -moz-border-radius: 24px;
      a {
        
        font-size: 14px;
        color: #454545;
        letter-spacing: 2px;
      }
    }
  }
}

.paySuccess-tips {
  background-color: white;
  position: relative;
  padding: 16px 20px;
  .line {
    width: 100%;
    height: 0.5px;
    background: #ccc;
    margin-bottom: 16px;
  }
  .paySuccess-tips-title {
    color: #4a90e2;
    font-size: 12px;
  }
  .paySuccess-tips-content {
    font-size: 12px;
    color: #666666;
    margin-top: 11px;
    p {
      margin-bottom: 28px;
    }
  }
}

.notice-wrap {
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: #fff;
  .notice {
    margin-bottom: 0;
  }
  .shorex {
    padding-bottom: 15px;
  }
  .no-shorex {
    font-size: 12px;
    color: #808080;
    font-weight: normal;
    margin-top: 5px;
  }
  .selectShorex-css p {
    font-size: 14px;
    text-align: center;
    color: #666666;
  }
  .selectShorex-css span {
    display: inline-block;
    width: 122px;
    height: 40px;
    background: #fbc500;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-weight: 400;
    color: #454545;
    margin-left: 30%;
  }
}
.bottom_img {
  margin-bottom: -50px;
  img {
    width: 100%;
    height: 100%;
  }
}

.notice {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 10px;
  padding: 17px 32px 14px 25px;
  background-color: #fff;
}
.notice-line {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  -moz-box-flex: 0;
  -ms-flex: none;
  flex: none;
  width: 3px;
  height: 14px;
  margin-right: 5px;
  background-color: #4a90e2;
  border-radius: 1px;
}
.notice-txt {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-size: 14px;
  line-height: 20px;
  color: #4a90e2;
  font-weight: 600;
}
.notice-item {
  margin: 0 15px 17px 25px;
  padding-left: 8px;
  border-bottom: 1px solid #cccccc;
  .line {
    display: inline-block;
    width: 86px;
    height: 0px;
    border-bottom: dotted 1px #ccc;
    position: relative;
    top: -3px;
    margin: 0px 5px;
  }
  .up-shorex {
    display: inline-block;
    width: 95px;
    height: 25px;
    background: #fbc500;
    text-align: center;
    line-height: 25px;
    font-size: 14px;
    font-weight: 600;
    color: #454545;
  }
  .notice-item-title {
    margin-bottom: 6px;
    font-size: 12px;
    line-height: 20px;
    color: #4a90e2;
  }

  .notice-item-text {
    padding-bottom: 5px;
    font-size: 12px;
    line-height: 20px;
    color: #666;
  }
  .shorex-item-tips {
    font-size: 12px;
    color: #666;
  }
}
.notice-item:last-child {
  margin-bottom: 0;
  border-bottom: none;
}
.survey-question-main{
  margin-top: 25px;
}
.shorex{
  text-align: center;
  margin-top: 15px;
  padding: 0 12px;
}
.shorex .shorex-title{
  
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #FCC300;
  margin-top: 9px;
  position: relative;
}

.shorex .shorex-title text{
  color: #006AB6;
}
.shorex .shorex-text{
  
  font-weight: 500;
  font-size: 12px;
  color: #000000;
  line-height: 17px;
  margin-bottom: 7px;
}
.shorex .shorex-img{
  width: 100%;
  height: 72px;
  margin-bottom: 14px;
}
.noShores{
  display: flex;
  align-items: center;
  padding: 0 21px;
  font-weight: 600;
  font-size: 13px;
  color: #282828;
  gap: 4px;
  & img{
    width: 15px;
    height: 15px;
  }
}
.hsbcBanner{
  width: 100%;
  height: 100px;
  margin: 20px 0;
  padding: 0 15px;
  &  .swiper-container {
    width: 100%;
    height: 100px;
    border-radius: 5px;
    overflow: hidden;
  }
  & .swiper-slide{
    width: 100%;
    height: 100px;
  }
  & img{
    width: 100%;
    height: 100px;
  }
}
</style>

